import {
  takeLatest,
  call,
  put,
  select,
} from 'redux-saga/effects';
import { ERROR_PASS_REQUEST, ERROR_UPDATE_REQUEST } from '@/action-types/error';
import { LOADING_UPDATE_REQUEST } from '@/action-types/loading';
import {
  VOCABULARY_FORCE_GET_REQUEST,
  VOCABULARY_GET_REQUEST,
  VOCABULARY_GET_SUCCESS,
} from '@/action-types/vocabulary';

import { getTrainingElements } from '@/api/training-element';
import {
  getWordProperties,
  getPhraseProperties,
} from '@/api/word';
import {
  createPropertiesArray,
  isNeedLoadVocabulary,
  updateVocabularyArray,
  updatePhrasesArray,
} from '@/services/book/vocabulary';

export function* getVocabulary(params: {
  state: any;
}) {
  const dataTraining = params.state?.exercise?.currentExercise?.dataTraining || [];

  try {
    yield put({ type: LOADING_UPDATE_REQUEST, name: 'vocabulary', state: true });
    const wordsArray = yield call(isNeedLoadVocabulary, params.state);

    if (wordsArray.properties.length) {
      let response: any = {};
      let vocabulary: any = {};

      if (wordsArray.type === 'words') {
        response = yield call(getWordProperties, wordsArray);
        vocabulary = yield call(updateVocabularyArray, response.data);
      } else if (wordsArray.type === 'phrases') {
        response = yield call(getPhraseProperties, wordsArray);
        vocabulary = yield call(updatePhrasesArray, response.data);
      }

      yield put({
        type: VOCABULARY_GET_SUCCESS,
        data: {
          exercise: {
            ...params.state.exercise,
            currentExercise: {
              ...params.state.exercise.currentExercise,
              dataTraining,
            },
          },
          vocabulary: {
            ...(params.state.vocabulary || {}),
            [wordsArray.type]: vocabulary,
          },
        },
      });
    }
  } catch (e) {
    yield put({ type: ERROR_PASS_REQUEST, error: e, tags: ['logic', 'getVocabulary'] });
    yield put({ type: ERROR_UPDATE_REQUEST, errorData: e });
  } finally {
    yield put({ type: LOADING_UPDATE_REQUEST, name: 'vocabulary', state: false });
  }
}

export function* forceGetVocabulary() {
  try {
    yield put({ type: LOADING_UPDATE_REQUEST, name: 'vocabulary', state: true });

    let receivedVocabulary = {};
    const state = yield select();
    const currentId = state.book.lesson?.currentId;
    const exerciseId = state.book.exercise?.exercises?.[currentId]?.lesson?.required || []
      .filter((el: { alias: string; }) => el.alias === 'flash-card')?.[0]?.id || 0;

    if (exerciseId) {
      const elements = yield call(getTrainingElements, { exerciseId });
      const wordsArray = yield call(createPropertiesArray, elements?.data?.getTrainingElements || [], 'words');

      if (wordsArray.properties.length) {
        const response = yield call(getWordProperties, wordsArray);
        receivedVocabulary = yield call(updateVocabularyArray, response);
      }

      yield put({
        type: VOCABULARY_GET_SUCCESS,
        data: {
          vocabulary: {
            ...(state.book.vocabulary || {}),
            words: receivedVocabulary,
          },
        },
      });
    }
  } catch (e) {
    yield put({ type: ERROR_PASS_REQUEST, error: e, tags: ['logic', 'forceGetVocabulary'] });
    yield put({ type: ERROR_UPDATE_REQUEST, errorData: e });
  } finally {
    yield put({ type: LOADING_UPDATE_REQUEST, name: 'vocabulary', state: false });
  }
}

export default function* vocabularySaga() {
  yield takeLatest<{ type: string; } & any>(VOCABULARY_GET_REQUEST, getVocabulary);
  yield takeLatest(VOCABULARY_FORCE_GET_REQUEST, forceGetVocabulary);
}
